import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  isShow = false;

  constructor() { }

  ngOnInit(): void {
  }

  onShowMenu(e: any) {
    this.isShow = e;
    const sidenav = document.getElementsByClassName('sidenav-content').item(0);
    if (!e) {
      setTimeout(() => {
        sidenav?.classList.add('ml-4-rem');
      }, 400);
    } else {
      sidenav?.classList.remove('ml-4-rem');
    }
  }

}
